const JUMIO_REGULARIZATION_BASE_ENDPOINT =
  '/company/b2b/legal-representatives/regularizations';

export const JUMIO_REGULARIZATION_REPRESENTATIVES_ENDPOINT = JUMIO_REGULARIZATION_BASE_ENDPOINT;

export const JUMIO_REGULARIZATION_PENDING_ENDPOINT = `${JUMIO_REGULARIZATION_BASE_ENDPOINT}/pending`;

export const JUMIO_REGULARIZATION_VERIFICATION_TOKEN_ENDPOINT = `${JUMIO_REGULARIZATION_BASE_ENDPOINT}/verification-token`;

export const JUMIO_REGULARIZATION_SYNC_ENDPOINT = `${JUMIO_REGULARIZATION_BASE_ENDPOINT}/sync`;

/**
 * Endpoint público que resuelve el token compartido: no lleva sesión ni headers
 * `Claim-*`, y es el que devuelve el estado vivo del workflow de Jumio.
 */
export const JUMIO_REGULARIZATION_PUBLIC_VERIFY_ENDPOINT =
  '/company/ext/legal-representatives/regularizations/verify';

/**
 * Ruta de la app que abre el representante legal. El backend devuelve solo el
 * token: la URL la arma el front contra el host del navegador, porque el destino
 * es una pantalla nuestra y no el endpoint.
 */
export const JUMIO_REGULARIZATION_VERIFY_PATH = 'verificacion-identidad';

/**
 * Estados que devuelve el endpoint público. Solo `PROCESSED` es terminal:
 * `INITIATED` trae link vivo y `ACQUIRED` significa que Jumio todavía procesa.
 */
export const JUMIO_REGULARIZATION_VERIFY_STATUS = {
  INITIATED: 'INITIATED',
  ACQUIRED: 'ACQUIRED',
  PROCESSED: 'PROCESSED',
} as const;

export const JUMIO_REGULARIZATION_VERIFY_POLL_MS = 5000;

/** Tope del sondeo del link publico. Mismo criterio que el panel. */
export const JUMIO_REGULARIZATION_VERIFY_POLL_MAX_ATTEMPTS = 60;

/** Custom element que registra el bundle de `@jumio/websdk`. */
export const JUMIO_SDK_ELEMENT_NAME = 'jumio-sdk';

/** Corte de seguridad: nunca dejar el loader puesto para siempre. */
export const JUMIO_SDK_READY_TIMEOUT_MS = 8000;

export const JUMIO_REGULARIZATION_CONFIRMATION_ENDPOINT =
  '/company/b2b/regularization/legal-representatives/data-reviews';

export const JUMIO_REGULARIZATION_FLAG_CODE = 'LEGAL_REP_REGULARIZATION';

export const JUMIO_REGULARIZATION_FLAG_ENDPOINT = `/company/b2b/feature-flags/${JUMIO_REGULARIZATION_FLAG_CODE}`;

export const JUMIO_REGULARIZATION_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
} as const;

export const JUMIO_REGULARIZATION_ALERT_IMAGE = 'warning-sign-yellow';

export const JUMIO_REGULARIZATION_URGENT_ALERT_IMAGE = 'alert';

export const JUMIO_REGULARIZATION_DEADLINE_DATE_FORMAT = 'YYYY-MM-DD';

export const JUMIO_REGULARIZATION_DEADLINE_LABEL_FORMAT = 'D [de] MMMM';

export const JUMIO_REGULARIZATION_EXTENDED_TITLE =
  'Extendimos el plazo para regularizar la verificación facial';

export const JUMIO_REGULARIZATION_DATE_PLACEHOLDER = '{date}';

export const JUMIO_REGULARIZATION_DAYS_PLACEHOLDER = '{days}';

export const JUMIO_REGULARIZATION_EXCLUSIVE_DATE_PHRASE = 'antes del {date}';

export const JUMIO_REGULARIZATION_INCLUSIVE_DATE_PHRASE = 'hasta el {date}';

export const JUMIO_REGULARIZATION_URGENT_TITLE =
  'Quedan {days} días para regularizar la verificación facial';

export const JUMIO_REGULARIZATION_URGENT_TITLE_SINGULAR =
  'Queda 1 día para regularizar la verificación facial';

export const JUMIO_REGULARIZATION_EXTENDED_DESCRIPTION_WITH_DATE =
  'Ahora, tienes plazo hasta el {date} para completar la validación. Toma menos de un minuto.';

export const JUMIO_REGULARIZATION_DEADLINE_ALERT_TITLE =
  'Recuerda que las validaciones deben hacerse antes del {date}';

export const JUMIO_REGULARIZATION_DEADLINE_ALERT_DESCRIPTION =
  'Si después de esta fecha hay validaciones de identidad pendientes, la empresa no podrá realizar transacciones hasta que se completen.';

export const JUMIO_REGULARIZATION_DEADLINE_ALERT_COUNTDOWN_DESCRIPTION =
  'Si después del {date} hay validaciones de identidad pendientes, la empresa no podrá realizar transacciones hasta que se completen.';

export const JUMIO_REGULARIZATION_PROMPT_TITLE =
  'Necesitamos validar la vigencia de tus representantes legales';

export const JUMIO_REGULARIZATION_STANDARD_DESCRIPTION =
  'Esta validación tomará menos de un minuto y debe ser realizada antes del {date}.';

export const JUMIO_REGULARIZATION_CONFIRM_DATA_LINK_LABEL = 'Revisar datos';

export const JUMIO_REGULARIZATION_PENDING_VALIDATIONS_TITLE =
  'Tienes validaciones de identidad pendientes.';

export const JUMIO_REGULARIZATION_PENDING_VALIDATIONS_DESCRIPTION =
  'Recuerda que después del {date} la empresa no podrá realizar transacciones hasta que se completen.';

export const JUMIO_REGULARIZATION_PENDING_VALIDATIONS_LINK_LABEL =
  'Revisar validaciones';

export const JUMIO_REGULARIZATION_REPORT_CHANGES_TOAST =
  'Gracias por la información. Te contactaremos, para actualizar los datos de tu cuenta.';

/**
 * Estado de la regularización de la empresa, que el flag devuelve en `status`.
 * `INITIATED` es la empresa sembrada que todavía no respondió; `IN_PROGRESS`
 * es la que confirmó vigencia. El backend apaga el flag solo cuando todos los
 * representantes quedan en `COMPLETED`.
 */
export const JUMIO_REGULARIZATION_FLAG_STATUS = {
  INITIATED: 'INITIATED',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING_UPDATE: 'PENDING_UPDATE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

/**
 * Sondeo del panel despues de que alguien termina su validacion. Va acotado
 * porque cada consulta a `/pending` pega contra ms-jumio y ademas puede
 * resolver el flag de la empresa: no es una lectura barata.
 */
export const JUMIO_REGULARIZATION_PENDING_POLL_MS = 5000;

export const JUMIO_REGULARIZATION_PENDING_POLL_MAX_ATTEMPTS = 12;
